import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline'

import Breadcrumb, { PathInterface } from '@/components/navigation/Breadcrumb'

import { FiltersRow } from './areaFilters/FiltersRow'
import { columns } from './Columns'
import { DataTable } from './DataTable'
import { TableContextProvider } from './TableContext'

const paths: PathInterface[] = [
  {
    name: 'Configuraciones',
  },
  {
    name: 'Mis áreas',
  },
]

export default function AreaList() {
  return (
    <div>
      <Breadcrumb
        icon={<ClipboardDocumentListIcon className="h-6 text-gray-500" />}
        paths={paths}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable columns={columns} />
      </TableContextProvider>
    </div>
  )
}
